import * as yup from 'yup';

export enum AccountType {
  Checking = 'Checking',
  Savings = 'Savings',
}

export const achInitialValues = {
  routingNumber: '',
  accountNumber: '',
  accountType: AccountType.Checking,
};

export const achValidation = yup.object().shape({
  routingNumber: yup
    .string()
    .required('Routing Number is required')
    .matches(/^\d+$/, 'Routing Number must only contain numbers'),

  accountNumber: yup
    .string()
    .required('Account Number is required')
    .matches(/^\d+$/, 'Account Number must only contain numbers'),
});
